import { createSlice } from '@reduxjs/toolkit'

const profileSlice = createSlice({
  name: 'profile',
  initialState: { member: null },
  reducers: {
    setCurrentMember: (state, action) => {
      state.member = action.payload
    },
    clearCurrentMember: (state) => {
      state.member = null
    },
  },
})

export const { clearCurrentMember, setCurrentMember } = profileSlice.actions
export const selectCurrentMember = (state) => state.profile.member
export default profileSlice.reducer
